/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const pay_from_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M20.25 8.5a.75.75 0 0 0 1.5 0h-1.5Zm1.5 12a.75.75 0 0 0-1.5 0h1.5ZM15.447 1.501l.323.677-.323-.677Zm1.388.616-.718.215.718-.215ZM15.5 13.75a.75.75 0 0 0 0 1.5v-1.5Zm4.47 2.72a.75.75 0 1 0 1.06 1.06l-1.06-1.06ZM23 14.5l.53.53a.75.75 0 0 0 0-1.06l-.53.53Zm-1.97-3.03a.75.75 0 1 0-1.06 1.06l1.06-1.06ZM19 22.25H3v1.5h16v-1.5ZM1.75 21V8H.25v13h1.5ZM3 22.25c-.69 0-1.25-.56-1.25-1.25H.25A2.75 2.75 0 0 0 3 23.75v-1.5Zm16 1.5A2.75 2.75 0 0 0 21.75 21h-1.5c0 .69-.56 1.25-1.25 1.25v1.5Zm0-17c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0 0 19 5.25v1.5ZM3 5.25A2.75 2.75 0 0 0 .25 8h1.5c0-.69.56-1.25 1.25-1.25v-1.5ZM20.25 8v.5h1.5V8h-1.5Zm0 12.5v.5h1.5v-.5h-1.5ZM3 6.75h3v-1.5H3v1.5Zm3.322-.073 9.448-4.499-.645-1.354-9.447 4.499.644 1.354ZM6 6.75h12v-1.5H6v1.5Zm12 0h1v-1.5h-1v1.5Zm-1.883-4.418 1.165 3.884 1.436-.431L17.553 1.9l-1.436.431Zm-.347-.154a.25.25 0 0 1 .347.154l1.436-.43A1.75 1.75 0 0 0 15.125.823l.645 1.354Zm5.26 15.352 2.5-2.5-1.06-1.06-2.5 2.5 1.06 1.06Zm2.5-3.56-2.5-2.5-1.06 1.06 2.5 2.5 1.06-1.06Zm-8.03 1.28H23v-1.5h-7.5v1.5Z"
    />
  </svg>
)
export default pay_from_medium
